import Vue from 'vue'
import objectToFormData from 'object-to-formdata'

const initialState = {
  detail: {},
  planItemDetail: {},
  plan: {},
  planGroup: {},
  planItem: {},
  list: [],
  planGroups: [],
  organizations: [],
  departments: [],
  deliveryTypes: [],
  registerBooks: [],
  appealCategories: [],
  types: [],
  regions: [],
  document: null,
  direct: {},
  upload: false,
  planControl: [],
  assignmentsControl: [],
  relatedDocumentsControl: [],
  resolutionTemplates: [],
  employeeExecutors: [],
  hierarchy: {},
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    },
    ADD_FILE(state, file) {
      state.detail = {
        ...state.detail,
        attachments: [...state.detail.attachments, file]
      }
    },
    REMOVE_FILE(state, fileId) {
      state.detail = {
        ...state.detail,
        attachments: state.detail.attachments.filter((file) => file.id !== fileId)
      }
    },
    ADD_COMMENT(state, comment) {
      state.detail = {
        ...state.detail,
        comments: [comment, ...state.detail.comments]
      }
    },
    EDIT_COMMENT(state, editedComment) {
      state.detail = {
        ...state.detail,
        comments: state.detail.comments.map(comment => {
          if (comment.id === editedComment.id) {
            return editedComment
          } else return comment
        })
      }
    },
    REMOVE_COMMENT(state, id) {
      state.detail = {
        ...state.detail,
        comments: state.detail.comments.filter((comment) => comment.id !== id)
      }
    },
    ADD_CORRESPONDENT(state, correspondent) {
      state.detail = {
        ...state.detail,
        correspondents: [...state.detail.correspondents, correspondent]
      }
    },
    REMOVE_CORRESPONDENT(state, correspondentId) {
      state.detail = {
        ...state.detail,
        correspondents: state.detail.correspondents.filter(correspondent => correspondent.id !== correspondentId)
      }
    }
  },
  actions: {
    getDetail({commit, state}, {documentId, category}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`docflow/documents/${category}/${documentId}/`).then(response => {
          commit('SET', {key: 'detail', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    list({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`docflow/documents/${params.category}/`, {params}).then(response => {
          commit('SET', {key: 'list', val: response.data.results})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getRelations({commit}, {category, documentId}) {
      let path = `docflow/documents/${category}/relations/`
      if (documentId) {
        path = `docflow/documents/${category}/relations/?document_id=${documentId}`
      }
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.get(path).then((response) => {
          commit('SET', {key: 'deliveryTypes', val: response.data.delivery_types})
          commit('SET', {key: 'types', val: response.data.types})
          commit('SET', {key: 'regions', val: response.data.regions})
          commit('SET', {key: 'document', val: response.data.document})
          commit('SET', {key: 'resolutionTemplates', val: response.data.resolution_templates})
          commit('SET', {key: 'registerBooks', val: response.data.register_books})
          commit('SET', {key: 'appealCategories', val: response.data.appeal_categories})
          commit('SET', {key: 'employeeExecutors', val: response.data.employee_executors})
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    create({commit}, document) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`docflow/documents/${document.category}/`, objectToFormData(document), {
          headers: {'Content-Type': 'multipart/form-data'}
        }).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    update({commit}, document) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.patch(`docflow/documents/${document.category}/${document.id}/`, objectToFormData(document), {
          headers: {'Content-Type': 'multipart/form-data'}
        }).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    uploadFile({commit, state}, {file, type, id}) {
      let documentId = id || state.detail.id
      let data = new FormData()
      data.append('file', file)
      if (type)
        data.append('type', type)
      commit('SET', {key: 'upload', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`docflow/documents/${documentId}/attachments/`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          commit('ADD_FILE', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'upload', val: false})
        })
      })
    },
    removeFile({commit, state}, {fileId, documentId}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(`docflow/documents/${documentId}/attachments/${fileId}/`).then(() => {
          commit('REMOVE_FILE', fileId)
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    createComment({commit, state}, {text, id}) {
      let documentId = id || state.detail.id
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`docflow/documents/${documentId}/comments/`, {text}).then(response => {
          commit('ADD_COMMENT', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    updateComment({commit, state}, {text, id}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.patch(`docflow/documents/${state.detail.id}/comments/${id}/`, {text}).then(response => {
          commit('EDIT_COMMENT', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    removeComment({commit, state}, id) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.delete(`docflow/documents/${state.detail.id}/comments/${id}/`).then(() => {
          commit('REMOVE_COMMENT', id)
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    createResolution({commit}, resolution) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.patch(`docflow/documents/${resolution.documentId}/fill_resolution/`, resolution).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    updateResolution({commit}, resolution) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.patch(`docflow/documents/${resolution.id}/fill_resolution/`, resolution).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    nextState({commit, state}, params = {}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        let documentId = params._documentId || state.detail.id
        Vue.axios.post(`docflow/documents/${documentId}/next_state/`, params).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    attachRegistrationNumber({commit, state}, params) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.patch(`docflow/documents/outgoing/${state.detail.id}/attach_registration_number/`, objectToFormData(params), {
          headers: {'Content-Type': 'multipart/form-data'}
        }).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    reject({commit, state}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        // @params - string or object
        // in case if @params is string we take value as note string
        // otherwise we'll got an object with two params:
        // @id - document id
        // @note - note string
        let note = typeof params === "string" ? params : params.note
        let documentId = typeof params === "object" ? params.id : state.detail.id
        Vue.axios.post(`docflow/documents/${documentId}/reject/`, {note}).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    addCorrespondent({commit, state}, correspondent) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`docflow/documents/${state.detail.id}/correspondents/`, correspondent).then((response) => {
          commit('ADD_CORRESPONDENT', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    removeCorrespondent({commit, state}, correspondentId) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(
          `docflow/documents/${state.detail.id}/correspondents/${correspondentId}/`
        ).then(() => {
          commit('REMOVE_CORRESPONDENT', correspondentId)
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    addItemCorrespondent({commit, state}, {documentId, itemId, correspondent}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(
          `docflow/documents/${documentId}/plan_items/${itemId}/executors/`, correspondent
        ).then((response) => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    removeItemCorrespondent({commit, state}, {documentId, itemId, correspondentId}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(
          `docflow/documents/${documentId}/plan_items/${itemId}/executors/${correspondentId}/`
        ).then(() => {
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getPlanDetail({commit, state}, planId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`docflow/documents/${state.detail.id}/plans/${planId}/`).then(response => {
          commit('SET', {key: 'plan', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    createPlanGroup({commit, state}, {planGroup, documentId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`docflow/documents/${documentId}/plan_groups/`, planGroup).then((response) => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    updatePlanGroup({commit, state}, {documentId, groupForm}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.patch(`docflow/documents/${documentId}/plan_groups/${groupForm.id}/`, groupForm).then((response) => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    updatePlanItem({commit, state}, {documentId, itemForm}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.patch(`docflow/documents/${documentId}/plan_items/${itemForm.id}/`, itemForm).then((response) => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    removePlanItem({commit, state}, itemId) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(`docflow/documents/${state.detail.id}/plan_items/${itemId}/`).then(() => {
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    removePlanGroup({commit, state}, groupId) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(`docflow/documents/${state.detail.id}/plan_groups/${groupId}/`).then(() => {
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    createPlanItem({commit, state}, {planItem, documentId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`docflow/documents/${documentId}/plan_items/`, planItem).then((response) => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    planItemRelations({commit, state}, {documentId, itemId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.get(`docflow/documents/${documentId}/plan_items/relations/?item_id=${itemId}`).then((response) => {
          commit('SET', {key: 'planGroups', val: response.data.groups})
          commit('SET', {key: 'organizations', val: response.data.organizations})
          commit('SET', {key: 'departments', val: response.data.departments})
          commit('SET', {
            key: 'planItem', val: {
              ...response.data.item,
              change_state: response.data.document.change_state
            }
          })
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    planGroupRelations({commit, state}, {documentId, groupId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.get(`docflow/documents/${documentId}/plan_groups/relations/?group_id=${groupId}`).then((response) => {
          commit('SET', {key: 'planGroup', val: response.data.group})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getItemDetail({commit, state}, {documentId, itemId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`docflow/documents/${documentId}/plan_items/${itemId}/`).then(response => {
          commit('SET', {key: 'planItemDetail', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    createCheckouts({commit, state}, employee) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`docflow/documents/${state.detail.id}/checkouts/`, {employee}).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    removeCheckouts({commit, state}, checkoutId) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(`docflow/documents/${state.detail.id}/checkouts/${checkoutId}/`).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    checkout({commit, state}, id = null) {
      commit('SET', {key: 'loading', val: true})
      let documentID = id || state.detail.id
      return new Promise((resolve, reject) => {
        Vue.axios.post(`docflow/documents/${documentID}/checkout/`).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    rejectCheckout({commit, state}, note) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`docflow/documents/${state.detail.id}/reject_checkout/`, {note}).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    register({commit, state}, document) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`docflow/documents/for_registration/${document.id}/register/`, document).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    remove({commit, state}, documentId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.delete(`docflow/documents/${state.detail.id}/`).then(() => {
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    cancel({commit, state}, note) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.post(`docflow/documents/${state.detail.id}/cancel/`, {note}).then(() => {
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getPlanControl({commit, state}, documentId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`docflow/documents/${documentId}/plan_control/`).then(response => {
          commit('SET', {key: 'planControl', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getAssignmentsControl({commit, state}, documentId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`docflow/documents/${documentId}/assignments_control/`).then(response => {
          commit('SET', {key: 'assignmentsControl', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getRelatedDocumentsControl({commit, state}, documentId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`docflow/documents/${documentId}/related_documents_control/`).then(response => {
          commit('SET', {key: 'relatedDocumentsControl', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getCloseReport({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.get(`docflow/documents/${state.detail.id}/generate_close_report/`).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getDocumentByHash({commit, state}, hash) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.get(`docflow/direct/${hash}/`).then(response => {
          commit('SET', {key: 'direct', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    extendTermDate({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`docflow/documents/${state.detail.id}/extend_term_date/`, payload).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    createChangeRequest({commit, state}, payload) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`docflow/documents/${state.detail.id}/change_request/create/`, objectToFormData(payload), {
          headers: {'Content-Type': 'multipart/form-data'}
        }).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    approveChangeRequest({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`docflow/documents/${state.detail.id}/change_request/approve/`).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    rejectChangeRequest({commit, state}, note) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`docflow/documents/${state.detail.id}/change_request/reject/`, {note}).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    doneChangeRequest({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`docflow/documents/${state.detail.id}/change_request/done/`).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getHierarchy({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.get(`docflow/documents/hierarchy/`, {params}).then(response => {
          commit('SET', {key: 'hierarchy', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    }
  }
}
